import FiscalYearsPage from './FiscalYearsPage';

export default FiscalYearsPage;
